import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function AnonymousUser() {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <Avatar label={i18n.t('surveys.form.responses.anonymous_user')} />
      <Text.Normal weight="medium">{i18n.t('surveys.form.responses.anonymous_user')}</Text.Normal>
    </Box>
  )
}
